import { render, staticRenderFns } from "./MyStaffKPIDetails.vue?vue&type=template&id=4c0ebd82&scoped=true"
import script from "./MyStaffKPIDetails.vue?vue&type=script&lang=js"
export * from "./MyStaffKPIDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0ebd82",
  null
  
)

export default component.exports